import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import Cookies from 'js-cookie';

const { Post } = require('Xhr/Xhr');

export const GetPacsConfer = (
  setPacsConfer,
  idPatientString
) => {
  const user =
    Cookies.get('user') && JSON.parse(Cookies.get('user'));

 
    console.log('---->',  {
      idPatient: idPatientString || user?.IdPatient,
    })


  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_PATIENT_PACS_CONFER}`,
    true,
    {
      idPatient: idPatientString || user?.IdPatient,
    }
  ).then((response) => {
     
    if (response.data.resCode !== -1) {
      if(response.data.Data?.lst){
        setPacsConfer(response.data.Data.lst);
      }else{
        setPacsConfer([])
      }
      
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
